import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Home from "../pages/Home";
import About from "../pages/About";
import Trips from "../pages/Trips";
import ServiceDetails from "../pages/ServiceDetails";
import CarRental from "../pages/CarListings";
import CarBooking from "../pages/CarDetails";
import Products from "../pages/Products";
import ProductDetails from "../pages/ProductDetails";

import Checkout from "../pages/Checkout";
import Host from "../pages/host";
import BlogDetails from "../pages/BlogDetails";
import SignIn from "../pages/SignIn";
import SignUp from "../pages/SignUp";
import Contact from "../pages/Contact";
import NotFound from "../pages/NotFound";
import TripDetails from "../pages/TripDetails";
import TopRatedListings from "../pages/topRatedHostCars";

const routes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      {/* <Route path="/home" element={<Home />} /> */}

      <Route path="/about" element={<About />} />
      <Route path="/trips" element={<Trips />} />
      <Route path="/service-details/:id" element={<ServiceDetails />} />
      <Route path="/car-listing" element={<CarRental />} />
      <Route path="/car-details/:id" element={<CarBooking />} />
      <Route path="/products" element={<Products />} />
      <Route path="/product-details/:id" element={<ProductDetails />} />

      <Route path="/checkout" element={<Checkout />} />
      <Route path="/host" element={<Host />} />
      <Route path="/blog-details/:id" element={<BlogDetails />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/TripDetails" element={<TripDetails />} />
      <Route path="/TopRatedListings" element={<TopRatedListings />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default routes;
